import axios from "@/axios";

const state = () => ({
  current_draft: {},
  drafts_list: [],
  first_load: false,
  select_id: 0,
  readonly: false,
  history_list: [],
  total: 0,
  per_page: 0,
  filter_params: {
    page: 1,
    user: null,
    status: null
  }
});

const mutations = {
  setDraft(state, draft) {
    state.current_draft = draft;
  },
  setDraftList(state, drafts) {
    state.drafts_list = drafts;
  },
  setFirstLoad(state, status) {
    state.first_load = status;
  },
  setTotalCount(state, total) {
    state.total = total;
  },
  setPerPage(state, per_page) {
    state.per_page = per_page;
  },
  setSelectId(state, id) {
    state.select_id = id;
  },
  setHistoryList(state, list) {
    state.history_list = list;
  },
  setFilterParams(state, data) {
    state.filter_params[data.fieldCode] = data.params;
  },
  resetFilterParams(state) {
    state.filter_params = {
      page: 1,
      user: null,
      status: null
    }
  },
  setReadonly(state, status) {
    state.readonly = status;
  },
};

const actions = {
  // загружаем информацию о текущем черновике
  async fetch({ commit }) {
    const { data } = await axios("/drafts/current-header");
    commit("setDraft", data["result"]["draft"]);
  },
  async fetchAll({ commit }, { isFirst }) {
    const { data } = await axios("/drafts/all-currents");
    commit("setDraftList", data["items"]["items"]);
    if (isFirst) {
      commit("setFirstLoad", isFirst);
    }
  },
  async setHistoryList({ commit, state }) {
    const { data } = await axios('/drafts/history', {
      params: {
        page: state.filter_params.page,
        user: state.filter_params.user,
        status: state.filter_params.status
      }
    });
    commit("setHistoryList", data["result"]["items"]);
    commit("setTotalCount", data["result"]["total"]);
    commit("setPerPage", data["result"]["per_page"]);
  },
  setFilterParams({ commit }, { data }) {
    commit("setFilterParams", data);
  },
  resetFilterParams({ commit }) {
    commit("resetFilterParams");
  },
  setReadonly({ commit }, { status }) {
    commit("setReadonly", status);
  },
  setSelectId({ commit }, { id }) {
    commit("setSelectId", id);
  },
};

const getters = {
  currentDraft: (state) => state.current_draft,
  draftsList: (state) => state.drafts_list,
  firstLoad: (state) => state.first_load,
  selectId: (state) => state.select_id,
  history: (state) => state.history_list,
  readonly: (state) => state.readonly,
  total: (state) => state.total,
  perPage: (state) => state.per_page,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
